import React from "react";

import { Button, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { trackEvent } from "@/components/GA.component";
import { getSalesCalendarLink, getUrlLangPrefix } from "@/utils/Local";

import FaCheckCircle from "../../assets/icons/faCheckCircle.svg";
import FaHome from "../../assets/icons/faHome.svg";
import useContactContext from "../../hooks/useContactContext";
import i18n from "../../i18n";

import type { ContactCategory } from "@/context/ContactProvider.context";

const RenderSuccessMsg: React.FC<{ category: ContactCategory }> = ({
  category,
}) => {
  const { t } = i18n;
  const calendarLink = getSalesCalendarLink();

  switch (category) {
    case "affordable":
      return (
        <React.Fragment>
          <p className="m-0">
            {t(
              "Thank you for your interest. Our team will reach out shortly. You may also book a meeting here:",
            )}
          </p>
          <Button
            onClick={() => {
              trackEvent(`contact_us_click_calendar`, {
                category,
              });
            }}
          >
            <a href={calendarLink} rel="noreferrer" target="_blank">
              {t("schedule_a_call")}
            </a>
          </Button>
        </React.Fragment>
      );
    case "builders":
      return (
        <React.Fragment>
          <p className="m-0">
            {t(
              "Thank you for contacting us. We’ll be in touch shortly. You may also book a meeting here:",
            )}
          </p>
          <Button
            onClick={() => {
              trackEvent(`contact_us_click_calendar`, {
                category,
              });
            }}
          >
            <a href={calendarLink} rel="noreferrer" target="_blank">
              {t("schedule_a_call")}
            </a>
          </Button>
        </React.Fragment>
      );
    case "homeowners":
      return (
        <p>
          {t(
            "Thank you for reaching out. We’ll contact you soon to discuss your project.",
          )}
        </p>
      );
    case "investors":
      return (
        <React.Fragment>
          <p className="m-0">
            {t(
              "Thank you for reaching out. We will be in touch shortly to learn more about your investment goals.",
            )}
          </p>
          <Button
            onClick={() => {
              trackEvent(`contact_us_click_calendar`, {
                category,
              });
            }}
          >
            <a href={calendarLink} rel="noreferrer" target="_blank">
              {t("schedule_a_call")}
            </a>
          </Button>
        </React.Fragment>
      );
    default:
      return null;
  }
};

const ContactFormSuccess = (): React.JSX.Element | null => {
  const { t } = i18n;
  const { category, cleanup } = useContactContext();

  if (!category) {
    return null;
  }

  return (
    <Container>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "70vh" }}
      >
        <div className="d-flex flex-column justify-content-between align-items-center gap-3 w-50 text-center w-100">
          <img alt={t(`contact-success`)} src={FaCheckCircle} />
          <h1>{t(`Form submitted successfully.`)}</h1>
          <RenderSuccessMsg category={category} />
          <NavLink
            className="mt-2"
            to={`${getUrlLangPrefix()}/`}
            onClick={() => {
              cleanup();
            }}
          >
            <Button variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2">
              <img alt={t(`home`)} src={FaHome} />
              <span>{t("go_to_homepage")}</span>
            </Button>
          </NavLink>
        </div>
      </div>
    </Container>
  );
};

export default ContactFormSuccess;
